<template>
    <DigitalPrintingRequestTable></DigitalPrintingRequestTable>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const DigitalPrintingRequestTable = defineAsyncComponent(() =>
    import(
        "../../components/Decoration/DigitalPrintingRequestTable.vue"
        )
);
export default {
    name: "DigitalPrintingRequestList",
    components: { DigitalPrintingRequestTable, AuthLayout },
}
</script>
